








































































































































import Vue from "vue";
import axios from 'axios';

import VariableInput from "@/components/util/VariableInput.vue";
import SelectBox from "@/components/util/SelectBox.vue";
import TenderSituationModal from "@/parts/tender/TenderSituationModal.vue";
import MessageModal from "@/parts/util/MessageModal.vue";
import { ErrorResponse } from '@/api/dto/Error';

import { QustionType } from "@/api/dto/Tender";
import { getTender, createTender, deleteTender } from "@/api/Tender";
import { getDeal } from "@/api/Deal";

/** モード（ create: 新規、edit: 更新 ） */
type Mode = "create" | "edit";

/** data の型定義 */
type Data = {
  /** 取引 ID */
  dealId: string;
  /** 新規 or 更新 */
  mode: Mode;
  /** 質問回数 */
  questionLimitList: {
    value: number;
    text: string;
  }[];
  /** 入札情報 */
  tenderInfo: {
    /** 依頼名 */
    title: string;
    /**
     * 受注希望金額
     * NOTE: レビュー依頼金額
     */
    reviewAmount?: number;
    /** 入札金額/受注金額 */
    amount: string;
    /** 質問回数 */
    questionLimit: number;
    /** コメント */
    comment?: string;
  };
  /** 入札完了モーダル 表示するかどうか */
  visibleCompleteModal: boolean;
  /** 取消確認モーダル 表示するかどうか */
  visibleConfirmModal: boolean;
  /** 入札状況モーダル 表示するかどうか */
  visibleTenderSituationModal: boolean;
  /** 遷移元情報 */
  fromName: string | null | undefined;
};

export default Vue.extend({
  name: "TenderSetting",
  components: {
    VariableInput,
    SelectBox,
    TenderSituationModal,
    MessageModal,
  },
  data(): Data {
    return {
      dealId: "",
      mode: "create",
      questionLimitList: [
        { value: 0, text: "無制限" },
        { value: 3, text: "3回" },
        { value: 5, text: "5回" },
        { value: 10, text: "10回" },
      ],
      tenderInfo: {
        title: "",
        amount: "",
        questionLimit: 0,
      },
      visibleCompleteModal: false,
      visibleConfirmModal: false,
      visibleTenderSituationModal: false,
      fromName: "",
    };
  },
  computed: {
    /** 新規作成かどうか */
    isCreateMode(): boolean {
      return this.mode === "create";
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      ((vm.$data as Data).fromName = from.name)
      vm.$emit('isLoaded', false);
    });
  },
  beforeRouteUpdate(to, from, next) {
    next((vm) => ((vm.$data as Data).fromName = from.name));
  },
  created() {
    this.load(this.$route.params.dealId);
  },
  methods: {
    /** 初期表示 */
    async load(dealId: string) {
      this.dealId = dealId;
      const [lastPart] = this.$route.path.match(/[^\/]+$/) ?? [];
      this.mode = lastPart as Mode;

      if (this.mode === "create") {
        try {
          // 新規
          const response = await getDeal(this.dealId);
          this.tenderInfo = {
            title: response.title,
            reviewAmount: response.amount,
            amount: "",
            questionLimit: 0,
            comment: "",
          };
        } catch (e) {
          this.$router.replace({ name: "Top" });
        } finally {
          this.$emit('isLoaded', true);
        }
      } else {
        try {
          // 更新
          const response = await getTender(this.dealId);
          this.tenderInfo = {
            title: response.title,
            reviewAmount: response.amount,
            amount: (response.desiredAmount ?? 0).toString(),
            questionLimit: response.questionLimit ?? 0,
            comment: response.comment,
          };
        } catch (e) {
          this.$router.replace({ name: "Top" });
        } finally {
          this.$emit('isLoaded', true);
        }
      }
    },
    /** 質問回数 change ハンドラ */
    handleChangeQuestionLimit(questionLimit: number) {
      this.tenderInfo.questionLimit = questionLimit;
    },
    /** 依頼詳細を表示ボタン click ハンドラ */
    handleClickReviewDetail() {
      this.$router.push({
        name: "Review",
        params: { dealId: this.dealId },
      });
    },
    /** 入札する */
    async handleSubmit() {
      // バリデーションチェック
      var validation = this.validation();
      if (!validation.result) {
        this.$emit("errorToast", validation.message);
        return;
      }

      const { amount, questionLimit, comment } = this.tenderInfo;

      // 登録処理が成功したかどうか
      let isSucceed = true;

      try {
        // 入札情報登録
        await createTender({
          dealId: this.dealId,
          amount: Number(amount),
          questionType: questionLimit
            ? QustionType.Limited
            : QustionType.UnLimited,
          questionLimit,
          comment,
        });
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message == null) {
            if (this.isCreateMode) {
              this.$emit("errorToast", "入札情報の登録に失敗しました。");
            } else {
              this.$emit("errorToast", "入札情報の更新に失敗しました");
            }
          } else {
            this.$emit('errorToast', resError.message);
            if(resError.message != "禁止ワードが含まれているため送信に失敗しました") {
            this.$router.push({ name: "Top" });
            }
          }
          isSucceed = false;
        }
      } finally {
        if (!isSucceed) {
          return;
        }
        if (this.isCreateMode) {
          this.visibleCompleteModal = true;
        } else {
          this.$emit("toast", "入札を更新しました");
        }
      }
    },
    /** 取引管理画面へ */
    handleClickToDealsManagement() {
      this.$router.push({ name: "DealsManagement" });
    },
    /** 入札を取り消す　click ハンドラ */
    handleClickDeleteTender() {
      try {
        deleteTender(this.dealId);
      } catch (e) {
        this.$emit("errorToast", "入札情報の削除に失敗しました");
        return;
      } finally {
        this.toPreviousPage();
      }
    },
    /** 遷移元に移動 */
    toPreviousPage() {
      if (this.isCreateMode) {
        // 新規入札の場合はレビュー詳細へ遷移
        this.$router.push({
          name: "Review",
          params: { dealId: this.dealId },
        });
      } else {
        // 遷移元が取得できない場合は TOP へ遷移
        if (!this.fromName) {
          this.$router.push({ name: "Top" });
        } else {
          this.$router.push({
            name: this.fromName,
            // NOTE: 遷移元がレビュー詳細の場合、取引 ID をパラメータに設定
            ...(this.fromName === "Review" && {
              params: { dealId: this.dealId },
            }),
          });
        }
      }
    },
    /** バリデーション */
    validation() {
      const form = this.tenderInfo;
      const amount = Number(form.amount);
      const comment = form.comment;

      const commentLength = 250;
      const amountMin = 3000;
      const amountMax = 20000;

      // 金額
      if (isNaN(amount) || amount < amountMin || amountMax < amount) {
        return {
          result: false,
          message: `金額を${amountMin.toLocaleString()}円以上${amountMax.toLocaleString()}円以内で入力してください`,
        };
      }

      if(Math.floor(amount / 100) * 100 !== amount){
        // 金額が 100 円単位の入力になっているか
        return { 
          result: false,
          message: '金額は100円単位で入力してください' 
        };
      }

      // コメント
      if (comment && comment.length > commentLength) {
        return {
          result: false,
          message: `コメントは${commentLength}文字以内で入力してください。`,
        };
      }

      return { result: true, message: "" };
    },
  },
});
